import { render, staticRenderFns } from "./main-user-area.vue?vue&type=template&id=547a9f14&"
import script from "./main-user-area.vue?vue&type=script&lang=js&"
export * from "./main-user-area.vue?vue&type=script&lang=js&"
import style0 from "./main-user-area.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports